// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UKWHLJNBITXjSI {
  display: flex;
  position: absolute;
  z-index: 999;
  flex-direction: column;
  align-content: center;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  border-radius: var(--ds-border-radius-300, 12px);
  background: var(--ds-surface-raised, #ffffff);
  font-weight: var(--ds-font-weight-bold, 700);
  line-height: 36px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hoverFiles": `UKWHLJNBITXjSI`
};
export default ___CSS_LOADER_EXPORT___;
